import React from "react";
import hackathonData from "./hackData.js";
import "./Hackathons.css";

// Simple SVG icons
const GithubIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="100"
    height="100"
    viewBox="0 0 48 48"
  >
    <path
      fill="#fff"
      d="M41,24c0,9.4-7.6,17-17,17S7,33.4,7,24S14.6,7,24,7S41,14.6,41,24z"
    ></path>
    <path
      fill="#455a64"
      d="M21 41v-5.5c0-.3.2-.5.5-.5s.5.2.5.5V41h2v-6.5c0-.3.2-.5.5-.5s.5.2.5.5V41h2v-5.5c0-.3.2-.5.5-.5s.5.2.5.5V41h1.8c.2-.3.2-.6.2-1.1V36c0-2.2-1.9-5.2-4.3-5.2h-2.5c-2.3 0-4.3 3.1-4.3 5.2v3.9c0 .4.1.8.2 1.1L21 41 21 41zM40.1 26.4C40.1 26.4 40.1 26.4 40.1 26.4c0 0-1.3-.4-2.4-.4 0 0-.1 0-.1 0-1.1 0-2.9.3-2.9.3-.1 0-.1 0-.1-.1 0-.1 0-.1.1-.1.1 0 2-.3 3.1-.3 1.1 0 2.4.4 2.5.4.1 0 .1.1.1.2C40.2 26.3 40.2 26.4 40.1 26.4zM39.8 27.2C39.8 27.2 39.8 27.2 39.8 27.2c0 0-1.4-.4-2.6-.4-.9 0-3 .2-3.1.2-.1 0-.1 0-.1-.1 0-.1 0-.1.1-.1.1 0 2.2-.2 3.1-.2 1.3 0 2.6.4 2.6.4.1 0 .1.1.1.2C39.9 27.1 39.9 27.2 39.8 27.2zM7.8 26.4c-.1 0-.1 0-.1-.1 0-.1 0-.1.1-.2.8-.2 2.4-.5 3.3-.5.8 0 3.5.2 3.6.2.1 0 .1.1.1.1 0 .1-.1.1-.1.1 0 0-2.7-.2-3.5-.2C10.1 26 8.6 26.2 7.8 26.4 7.8 26.4 7.8 26.4 7.8 26.4zM8.2 27.9c0 0-.1 0-.1-.1 0-.1 0-.1 0-.2.1 0 1.4-.8 2.9-1 1.3-.2 4 .1 4.2.1.1 0 .1.1.1.1 0 .1-.1.1-.1.1 0 0 0 0 0 0 0 0-2.8-.3-4.1-.1C9.6 27.1 8.2 27.9 8.2 27.9 8.2 27.9 8.2 27.9 8.2 27.9z"
    ></path>
    <path
      fill="#455a64"
      d="M14.2,23.5c0-4.4,4.6-8.5,10.3-8.5c5.7,0,10.3,4,10.3,8.5S31.5,31,24.5,31S14.2,27.9,14.2,23.5z"
    ></path>
    <path
      fill="#455a64"
      d="M28.6 16.3c0 0 1.7-2.3 4.8-2.3 1.2 1.2.4 4.8 0 5.8L28.6 16.3zM20.4 16.3c0 0-1.7-2.3-4.8-2.3-1.2 1.2-.4 4.8 0 5.8L20.4 16.3zM20.1 35.9c0 0-2.3 0-2.8 0-1.2 0-2.3-.5-2.8-1.5-.6-1.1-1.1-2.3-2.6-3.3-.3-.2-.1-.4.4-.4.5.1 1.4.2 2.1 1.1.7.9 1.5 2 2.8 2 1.3 0 2.7 0 3.5-.9L20.1 35.9z"
    ></path>
    <path
      fill="#00bcd4"
      d="M24,4C13,4,4,13,4,24s9,20,20,20s20-9,20-20S35,4,24,4z M24,40c-8.8,0-16-7.2-16-16S15.2,8,24,8 s16,7.2,16,16S32.8,40,24,40z"
    ></path>
  </svg>
);

const DevpostIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="100"
    height="100"
    viewBox="0 0 48 48"
  >
    <path
      fill="#01579b"
      d="M35.063,6H12.938L2.85,24.006L13.197,42h21.865l10.084-18L35.063,6z"
    ></path>
    <path
      fill="#fff"
      d="M24.158,14H17v20h7.158C29.598,34,34,29.527,34,24C34,18.473,29.598,14,24.158,14z M24,30h-3V18h3c3.31,0,6,2.69,6,6S27.31,30,24,30z"
    ></path>
  </svg>
);

const Hackathons = () => (
  <div className="hackathons-section">
    <h2 className="hackathons-title">Hackathons</h2>
    <div className="hackathons-list">
      {hackathonData.map((hack, idx) => (
        <div className="hackathon-card" key={idx}>
          <div className="hackathon-header">
            <div className="hackathon-names">
              <span className="hackathon-name">{hack.name}</span>
              <span className="project-name">{hack.projectName}</span>
            </div>
            <span className="hackathon-year">{hack.year}</span>
          </div>
          <div className="hackathon-description">{hack.description}</div>
          <div className="hackathon-links">
            {hack.github && (
              <a
                className="hackathon-link"
                href={hack.github}
                target="_blank"
                rel="noopener noreferrer"
                title="GitHub Repo"
              >
                <GithubIcon />
              </a>
            )}
            {hack.devpost && (
              <a
                className="hackathon-link"
                href={hack.devpost}
                target="_blank"
                rel="noopener noreferrer"
                title="Devpost"
              >
                <DevpostIcon />
              </a>
            )}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default Hackathons;
